import { Model as o } from "../../../../../model.js";
class s extends o {
  constructor(e) {
    super(), this.codeType = e.codeType, this.legalUrl = e.legalUrl;
  }
}
export {
  s as LoyaltyProgrammeDesignModel
};
//# sourceMappingURL=loyaltyProgrammeDesign.model.js.map
